var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCentroAyudaSimacLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_8",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.246,
    height: 36.949,
    viewBox: "0 0 42.246 36.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33311",
    "data-name": "Grupo 33311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33309",
    "data-name": "Grupo 33309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21182",
    "data-name": "Trazado 21182",
    d: "M23.539,14.174A5.422,5.422,0,0,0,12.7,14.42a6.619,6.619,0,0,0,.616,2.586h0a2.692,2.692,0,0,0,.369.616L18,24.4l4.311-6.774c.123-.246.246-.369.369-.616h0A3.685,3.685,0,0,0,23.539,14.174Zm-5.173,1.847A1.724,1.724,0,1,1,20.09,14.3,1.684,1.684,0,0,1,18.366,16.021Z",
    transform: "translate(2.942 2.084)",
    fill: "#e0007e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33304",
    "data-name": "Grupo 33304",
    transform: "translate(8.745 6.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21183",
    "data-name": "Trazado 21183",
    d: "M27.545,29.879H11.534A4.415,4.415,0,0,1,7.1,25.445V9.434A4.415,4.415,0,0,1,11.534,5H27.545a4.415,4.415,0,0,1,4.434,4.434V25.445A4.581,4.581,0,0,1,27.545,29.879ZM11.534,7.586A1.894,1.894,0,0,0,9.686,9.434V25.445a1.894,1.894,0,0,0,1.847,1.847H27.545a1.894,1.894,0,0,0,1.847-1.847V9.434a1.894,1.894,0,0,0-1.847-1.847Z",
    transform: "translate(-7.1 -5)",
    fill: "#009ca2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33305",
    "data-name": "Grupo 33305",
    transform: "translate(37.442 7.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21184",
    "data-name": "Trazado 21184",
    d: "M35.2,31.279h-2.71A2.158,2.158,0,0,1,30.4,29.185V8.494A2.158,2.158,0,0,1,32.494,6.4H35.2V8.986h-2.34V28.693H35.2Z",
    transform: "translate(-30.4 -6.4)",
    fill: "#009ca2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33306",
    "data-name": "Grupo 33306",
    transform: "translate(6.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21185",
    "data-name": "Trazado 21185",
    d: "M31.98,4.927H7.717A2.185,2.185,0,0,1,5.5,2.833V0H8.086V2.34H31.611V0H34.2V2.71A2.208,2.208,0,0,1,31.98,4.927Z",
    transform: "translate(-5.5)",
    fill: "#009ca2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33307",
    "data-name": "Grupo 33307",
    transform: "translate(6.774 32.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21186",
    "data-name": "Trazado 21186",
    d: "M31.98,26H7.717A2.185,2.185,0,0,0,5.5,28.094v2.833H8.086v-2.34H31.611v2.34H34.2v-2.71A2.208,2.208,0,0,0,31.98,26Z",
    transform: "translate(-5.5 -26)",
    fill: "#009ca2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33308",
    "data-name": "Grupo 33308",
    transform: "translate(0 6.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21187",
    "data-name": "Trazado 21187",
    d: "M2.71,30.079H0V27.493H2.34V7.786H0V5.2H2.71A2.185,2.185,0,0,1,4.927,7.294V27.986A2.185,2.185,0,0,1,2.71,30.079Z",
    transform: "translate(0 -5.2)",
    fill: "#009ca2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentroAyudaSimacLogo);
export default __webpack_public_path__ + "static/media/Centro_ayuda_SIMAC_logo.528bcfbb6c3910d50bfa374eb2bc9499.svg";
export { ForwardRef as ReactComponent };